export default {"src":"/_next/static/media/progress.0fdf1ae7.svg","height":630,"width":657};